export function toNumber(a) {
    return Number(a);
}
//# sourceMappingURL=toNumber.js.map
